import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { EcsaBranchDTO, FindBranchesRq } from "@smartx/mikro-vt-client-api"
import { findBranchesApi } from "../../api/apiClient"
import { RequestHeader } from "../../utils/utils"
import type { RootState } from "../store"

interface IBranchesState {
  error: boolean
  isLoading: boolean
  list: Array<EcsaBranchDTO>
  selected: EcsaBranchDTO
}

const initialState: IBranchesState = {
  error: false,
  isLoading: false,
  list: [],
  selected: null,
}

const rq: FindBranchesRq = { header: new RequestHeader() }

export const findBranches = createAsyncThunk(
  "offers/findbranches",
  async () => {
    const response = await findBranchesApi.findBranches(rq)
    return response?.data
  },
)

export const branchesSlice = createSlice({
  name: "branches",
  initialState,
  reducers: {
    setBranch: (state, action: PayloadAction<EcsaBranchDTO>) => {
      state.selected = action.payload
    },
    setBranches: (state, action: PayloadAction<EcsaBranchDTO[]>) => {
      state.list = action.payload || []
    },
    clearBranch: (state) => {
      state.selected = null
    },
    clearBranches: (state) => {
      state.list = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(findBranches.pending, (state) => {
        state.isLoading = true
        state.error = false
      })
      .addCase(findBranches.fulfilled, (state, action) => {
        state.list = action.payload.branches || []
        state.isLoading = false
        state.error = false
        state.selected = null
      })
      .addCase(findBranches.rejected, (state) => {
        state.list = []
        state.isLoading = false
        state.error = true
        state.selected = null
      })
  },
})

export const { setBranch, setBranches, clearBranch, clearBranches } =
  branchesSlice.actions

export const selectBranches = (state: RootState) => state.branches.list

export default branchesSlice.reducer
